import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';

@Injectable({ providedIn: 'root' })
export class RoutesService extends BaseDataService {
  url = 'api/routes';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getPageRoles(): Promise<any> {
    return this.handleRequest(
      this.http.get(`${this.url}/pagesroles`),
      this.handlersFactory.getDefault(),
    );
  }

  getRouteRoles(): Promise<any> {
    return this.handleRequest(
      this.http.get(`${this.url}/routesroles`),
      this.handlersFactory.getDefault(),
    );
  }
}
